<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/set')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Create Set</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['Set/fetchSets']({ page: this.page });
              $router.push('/set');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Set Name*"
            v-model="createFields.name"
            :rules="validationRules.name"
            :error-messages="inputErrorMessages('name')"
            name="name"
            ref="name"
          ></v-text-field>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/set');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveSet">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Set name'),
          v => v.length <= 255 || 'Set name should not be greater than 255'
        ],
        amount: [
          v => !!v || this.rem('Price'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Price should be a number',
          v => v > 0 || 'Price should be greater than 0'
        ]
      },
      errorMessages: {},
      createFields: {
        amount: 0,
        name: ''
      }
    };
  },
  computed: {},
  mounted() {},
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['Set/fetchSets']),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveSet() {
      if (this.$refs.createForm.validate()) {
        axios
          .post('api/v1/set', this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Set created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['Set/fetchSets']({ page: this.page });
            this.clearCreate();
            if (this.continousCreation === false) {
              this.$router.push('/set');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    removeSpec(index) {
      this.createFields.meta.splice(index, 1);
    },
    addSpec(name, value) {
      if (!!name.trim()) {
        this.createFields.meta.push({
          specName: name,
          value: value
        });
        this.addSpecError = undefined;
      } else {
        this.addSpecError = [this.rem('Specification Name')];
      }
    }
  }
};
</script>